type CustomField = {
	fieldName: string;
	fieldValue: string;
};
export const searchFieldValue = <T extends CustomField>(
	data: T[] | undefined,
	fieldName: string,
) => {
	if (data === undefined) return null;
	for (const item of data) {
		if (item.fieldName === fieldName) {
			return item.fieldValue;
		}
	}
	return null;
};
